// extracted by mini-css-extract-plugin
module.exports = {"home-battery-D":"D_home-battery-D__kf2hr"};